// tuning/move.ts (M0-T06, §7.2)
import type { TuningBank } from '../schema/tuning';

export default {
  walk: 3.4, run: 6.4, radius: 0.38, speedTolerance: 1.25, slack: 0.6, residentHeight: 1.5,
  stuckGiveUpMs: 1500,   // simulation ms without headway before tap-to-walk re-plans around a resident in the way (or gives up)
} as const satisfies TuningBank;
